import { automationsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useAddDocument = () =>
  useMutation<unknown, unknown, FormData>((data) =>
    automationsRepo.addDocument(data),
  );
